import React, { useMemo } from 'react';

/**
 * Select unificado que combina:
 * - Presets cadastrados (vendedor + colaborador + eh_loja amarrados)
 * - Vendedores soltos vindos do n8n (sem preset)
 *
 * Valor selecionado é codificado como string:
 *   "" — todos
 *   "preset:<id>" — preset cadastrado
 *   "vendedor:<nome>" — vendedor solto sem preset
 */
const SeletorPreset = ({ presets = [], vendedoresN8n = [], value = '', onChange }) => {
  const presetsAtivos = useMemo(
    () => presets.filter(p => p.ativo !== false),
    [presets]
  );

  // Vendedores n8n que NÃO têm preset cadastrado (evita duplicar na lista)
  const vendedoresSemPreset = useMemo(() => {
    const cadastrados = new Set(presetsAtivos.map(p => (p.vendedor_nome || '').toLowerCase()));
    return vendedoresN8n.filter(v => v && !cadastrados.has(v.toLowerCase()));
  }, [presetsAtivos, vendedoresN8n]);

  const handleChange = (e) => {
    const val = e.target.value;
    if (!val) {
      onChange?.({ key: '', vendedor: '', colaborador: '', eh_loja: false, tipo: 'fixo' });
      return;
    }
    if (val.startsWith('preset:')) {
      const id = Number(val.slice('preset:'.length));
      const preset = presetsAtivos.find(p => p.id === id);
      if (preset) {
        const tipo = preset.tipo || 'comercial';
        onChange?.({
          key: val,
          vendedor: preset.vendedor_nome || '',
          colaborador: preset.colaborador_nome || '',
          eh_loja: tipo === 'loja',
          tipo,
        });
      }
      return;
    }
    if (val.startsWith('vendedor:')) {
      const nome = val.slice('vendedor:'.length);
      onChange?.({ key: val, vendedor: nome, colaborador: '', eh_loja: false, tipo: 'fixo' });
    }
  };

  return (
    <select
      className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-md px-3 py-2 text-sm text-[color:var(--text-primary)] min-w-[260px]"
      value={value}
      onChange={handleChange}
    >
      <option value="">Vendedor — Todos</option>

      {presetsAtivos.length > 0 && (
        <optgroup label="Presets cadastrados">
          {presetsAtivos.map(p => (
            <option key={`preset-${p.id}`} value={`preset:${p.id}`}>
              {p.nome}{p.eh_loja ? ' (Loja 10%)' : ''}
            </option>
          ))}
        </optgroup>
      )}

      {vendedoresSemPreset.length > 0 && (
        <optgroup label="Outros vendedores">
          {vendedoresSemPreset.map(v => (
            <option key={`v-${v}`} value={`vendedor:${v}`}>{v}</option>
          ))}
        </optgroup>
      )}
    </select>
  );
};

export default SeletorPreset;
